export const transformRequestChangeRefundMethod = ({ returnId, refund_method }) => ({
  returnId,
  payload: { refund_method },
})
